const SystemMainView = () => import('./');
const StepMemorizeView = () => import('./memo/views/Memo');
const StepGroupQuizView = () => import('./memo/views/Quiz/');

export default [
    {
        path: '/systems/:systemId/:groupName/:journeyName/:stepName',
        name: 'SystemMainView',
        component: SystemMainView
    },
    {
        path: '/systems/:systemId/:groupName/:journeyName/:stepName/memo',
        name: 'StepMemorizeView',
        component: StepMemorizeView
    },
    {
        path: '/systems/:systemId/:groupName/:journeyName/:stepName/quiz',
        name: 'StepsGroupQuizView',
        component: StepGroupQuizView
    }
];
